export enum MediatorEventType {
  FEEDBACK_OPEN = "BETA-PROGRAM:OPEN_FEEDBACK_WIDGET",
  FEEDBACK_SUBMIT = "BETA-PROGRAM:SUBMIT_FEEDBACK_WIDGET"
}
